/**
 * created by lei lei
 *锁共通
 */
import React, {Component} from 'react';
import {systemWebsocket} from "../auth";
import Lock from './lock'

let lockFactory = {
    tryLock:({type="lock", id, callback,showNotification=true})=>{
        let userId = window.currentUser.id||'';
        let name = window.currentUser.name||'';
        let data = {
            type,
            id,
            userId:userId,
            userName:name,
        };
        let lock = new Lock({data, callback,showNotification});
        systemWebsocket.addHandler(lock);
        return lock;
    }
};
export default lockFactory;